
(function(){
  const $  = (s,r=document)=>r.querySelector(s);
  const $$ = (s,r=document)=>Array.from(r.querySelectorAll(s));

  function parseJSON(id){
    const el=document.getElementById(id);
    if(!el) return null;
    try{ return JSON.parse(el.textContent);}catch(e){ return null;}
  }

  const productData = parseJSON('product-options-variant-data');
  const fabricData  = parseJSON('CylindoFabricData');
  if(!productData || !productData.product) return;

  const tabsRoot = document.getElementById('FabricTabs');
  if(!tabsRoot) return;

  // ----- Hover cards: event delegation (works across re-renders) -----
function initFabricHoverDelegation(){
  const hoverRoot = document.querySelector('[cylindo-fabric-hover-cards]');
  if (!hoverRoot) return;

  // helper: element onHover get title
  const pickTile = (el) => el && el.closest('.fabric-tile.cylindoVariant__option');

  const onOver = (e) => {
    const tile = pickTile(e.target);
    if (!tile || !tabsRoot.contains(tile)) return;

    const val = tile.getAttribute('data-value') || tile.querySelector('input[type="radio"]')?.value;
    if (!val) return;

    tile.classList.add('hovered');

    // remove exisitng hover, apply on matched one
    hoverRoot.querySelectorAll('.cylindoVariant__hover[hovered]')
             .forEach(n => n.removeAttribute('hovered'));

    hoverRoot.querySelectorAll(`.cylindoVariant__hover[data-value="${CSS.escape(val)}"]`)
             .forEach(n => n.setAttribute('hovered',''));
  };

  const onOut = (e) => {
    const tile = pickTile(e.target);
    if (!tile) return;

    if (tile.contains(e.relatedTarget)) return;

    const val = tile.getAttribute('data-value') || tile.querySelector('input[type="radio"]')?.value;
    tile.classList.remove('hovered');
    if (!val) return;

    hoverRoot.querySelectorAll(`.cylindoVariant__hover[data-value="${CSS.escape(val)}"]`)
             .forEach(n => n.removeAttribute('hovered'));
  };

  tabsRoot.addEventListener('pointerover', onOver);
  tabsRoot.addEventListener('pointerout',  onOut);
}



// ===== Hide-by-metafield helper =====
function shouldHideByMeta(valueForTarget, selection){
  
}


  // ----- Tabs availability helpers -----
function panelHasItems(panel){ 
  return !!panel && !!panel.querySelector('.js-panel-item'); 
}
function setDisabled(btn, disabled){
  if(!btn) return;
  if(disabled){
    btn.setAttribute('disabled','');
    btn.setAttribute('aria-disabled','true');
    btn.classList.add('is-disabled');
  } else {
    btn.removeAttribute('disabled');
    btn.setAttribute('aria-disabled','false');
    btn.classList.remove('is-disabled');
  }
}
function setActiveTab(tabKey){
  const btn   = tabsRoot.querySelector(`.fabric-tabs__btn[data-tab="${tabKey}"]`);
  const panel = tabsRoot.querySelector(`#panel-${tabKey}`);
  if(!btn || !panel) return;
  tabsRoot.querySelectorAll('.fabric-tabs__btn').forEach(b=>b.classList.remove('is-active'));
  tabsRoot.querySelectorAll('.fabric-tabs__panel').forEach(p=>p.classList.remove('is-active'));
  btn.classList.add('is-active');
  panel.classList.add('is-active');
}
function refreshTabsAvailability(){
  const has = {
    instock: panelHasItems(tabsRoot.querySelector('#panel-instock')),
    mto:     panelHasItems(tabsRoot.querySelector('#panel-mto')),
    sale:    panelHasItems(tabsRoot.querySelector('#panel-sale')),
  };

  setDisabled(tabsRoot.querySelector('.fabric-tabs__btn[data-tab="instock"]'), !has.instock);
  setDisabled(tabsRoot.querySelector('.fabric-tabs__btn[data-tab="mto"]'),     !has.mto);
  setDisabled(tabsRoot.querySelector('.fabric-tabs__btn[data-tab="sale"]'),    !has.sale);

  // agar user ne tab khud click kiya hai aur us panel me items hain => respect user
  const activeKey = tabsRoot.querySelector('.fabric-tabs__btn.is-active')?.dataset.tab;
  const keepUser  = tabsRoot.__userPicked && activeKey && has[activeKey];

  if (!keepUser){
    // PRIORITY: Instock -> MTO -> Sale
    const next = has.instock ? 'instock' : (has.mto ? 'mto' : (has.sale ? 'sale' : null));
    if (next) setActiveTab(next);
    else {
      // sab empty ho to sabse active hata do
      tabsRoot.querySelectorAll('.fabric-tabs__btn,.fabric-tabs__panel')
              .forEach(n=>n.classList.remove('is-active'));
    }
  }

  // optional: ek hi bucket visible ho to head hide
  // const visibleCount = (has.instock?1:0) + (has.mto?1:0) + (has.sale?1:0);
  // tabsRoot.querySelector('.fabric-tabs__head')?.classList
  //   .toggle('is-hidden', visibleCount <= 1);
}
// ===== Initial auto-pick (In-Stock first, else MTO) =====
function selectFirstInPanel(panelKey){
  const panel = tabsRoot.querySelector(`#panel-${panelKey}`);
  if (!panel) return false;

  const firstTile = panel.querySelector('.js-panel-item input[type="radio"]');
  if (!firstTile) return false;

  // Activate the tab (no .click() to avoid loops)
  setActiveTab(panelKey);

  // Select & sync
  if (!firstTile.checked) {
    firstTile.checked = true;
    firstTile.closest('.fabric-tile')?.classList.add('is-selected');

    // Safe: fire native events once so theme/URL/price update ho jaye
    // (tumne recursive dispatch fix kar diya hai, isliye yeh theek chalega)
    firstTile.dispatchEvent(new Event('input',  { bubbles:true }));
    firstTile.dispatchEvent(new Event('change', { bubbles:true }));
  }
  return true;
}

function autoPickOnLoad(){
  // Respect user if already clicked
  if (tabsRoot.__userPicked) return;

  // Ensure availability flags are up-to-date
  refreshTabsAvailability();

  // Try In-Stock, else MTO
  if (selectFirstInPanel('instock')) return;
  selectFirstInPanel('mto');
}



  // > 12 show more button
// ===== View More (simple + group-aware) =====
const SHOW_LIMIT = Number(tabsRoot?.dataset.showLimit || 12);

function applyViewMore(panelEl, limit = SHOW_LIMIT){
  // reset previous state
  panelEl.querySelectorAll('.fabric-tabs__more').forEach(n => n.remove());
  panelEl.querySelectorAll('.is-hidden').forEach(n => n.classList.remove('is-hidden'));

  const items = [...panelEl.querySelectorAll('.newLabelContainer')];
  if (items.length <= limit) return;

  // hide items beyond limit
  items.forEach((el, i) => { if (i >= limit) el.classList.add('is-hidden'); });

  // hide empty groups (only if groups exist; colors me groups nahi hote)
  [...panelEl.querySelectorAll('.fabric-group__items')].forEach(wrap => {
    const hasVisible = !!wrap.querySelector('.newLabelContainer:not(.is-hidden)');
    const title = wrap.previousElementSibling;
    if (!hasVisible){
      wrap.classList.add('is-hidden');
      if (title && title.classList.contains('cylindoVariant__groupTitle')){
        title.classList.add('is-hidden');
      }
    }
  });

  // add "View more" button
  const moreWrap = document.createElement('div');
  moreWrap.className = 'fabric-tabs__more';

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'fabric-tabs__moreBtn';
  btn.textContent = `View more (${items.length - limit})`;
  btn.addEventListener('click', () => {
    items.forEach(el => el.classList.remove('is-hidden'));
    panelEl.querySelectorAll('.fabric-group__items.is-hidden, .cylindoVariant__groupTitle.is-hidden')
           .forEach(el => el.classList.remove('is-hidden'));
    moreWrap.remove();
  });

  moreWrap.appendChild(btn);
  panelEl.appendChild(moreWrap);
}


  const variants          = productData.variants || [];
  const optionsWithValues = productData.options_with_values || [];

  // TARGET option (Fabric > Color > first)
  const TARGET_OPTION_NAME =
    (optionsWithValues.find(o=>o.name==='Fabric')?.name) ||
    (optionsWithValues.find(o=>o.name==='Color')?.name) ||
    (optionsWithValues[0]?.name || 'Fabric');

  const targetOption     = optionsWithValues.find(o=>o.name===TARGET_OPTION_NAME);
  const nonTargetOptions = optionsWithValues.filter(o=>o.name!==TARGET_OPTION_NAME);

  const HAS_FABRIC    = optionsWithValues.some(o => o.name === 'Fabric');
  const IS_COLOR_ONLY = !HAS_FABRIC && TARGET_OPTION_NAME === 'Color';

  const variantMetaList   = productData.variants_metafields || [];
  const productMetafields = productData.product_metafields || {};
  const INVENTORY_KEY     = (tabsRoot.dataset.inventoryKey || '5200 - MVN Warehouse').trim().toLowerCase();

  // variantId -> metafields
  const byIdMeta = new Map();
  variantMetaList.forEach((m,i)=>{ const v=variants[i]; if(v) byIdMeta.set(v.id,m); });

  // swatch images from option values
  const swatchByValue = new Map();
  if (targetOption && Array.isArray(targetOption.values)){
    targetOption.values.forEach(v=>{
      const name = v?.name || v?.value || v;
      const img = v?.swatch?.image || null;
      swatchByValue.set(name, img);
    });
  }

  // Optional metaobject fabric images (for fabrics)
  const metaFabricImg = new Map();
  if (fabricData && Array.isArray(fabricData.fabrics)){
    fabricData.fabrics.forEach(x=>{
      if (x?.fabric && x?.image?.url) metaFabricImg.set(x.fabric, x.image.url);
    });
  }

  function parseFabricLabel(value){
    const lr = String(value).split(' / ');
    const left = (lr[0]||'').trim();
    const color = (lr[1]||'').trim();
    const parts = left.split(',').map(s=>s.trim());
    const fabric = parts[0] || '';
    const desc = parts.slice(1).join(', ') || '';
    const groupTitle = desc ? `${fabric}, ${desc}` : fabric;
    return { fabric, desc, color, groupTitle };
  }

  function isAvailableAnywhere(variantId){
    const meta = byIdMeta.get(variantId);
    if(!meta) return false;
    if (meta.custom && meta.custom.availability === false) return false;

    const inv = meta.inventory || {};
    if (inv.available_at_locations != null){
      const n = Number(inv.available_at_locations);
      if(!Number.isNaN(n) && n>0) return true;
    }
    const locs = inv.available_counts_per_location;
    const getQty = r => Number(typeof r?.available==='number'? r.available : (r?.available || 0)) || 0;

    if (Array.isArray(locs)){
      if (locs.length && Array.isArray(locs[0])) return locs.reduce((a,e)=>a+getQty(e?.[1]),0) > 0;
      return locs.reduce((a,r)=>a+getQty(r),0) > 0;
    }
    if (locs && typeof locs==='object') return Object.values(locs).reduce((a,r)=>a+getQty(r),0) > 0;

    const v = variants.find(x=>x.id===variantId);
    return !!v?.available;
  }

  function isInStockAtLocation(variantId){
    const meta = byIdMeta.get(variantId);
    const locs = meta?.inventory?.available_counts_per_location;
    if(!locs) return false;

    const matchOne = (rec)=>{
      const nm = (rec?.name || rec?.location?.name || '').trim().toLowerCase();
      const qty = Number(typeof rec?.available==='number'? rec.available : (rec?.available||0)) || 0;
      return nm===INVENTORY_KEY && qty>0;
    };

    if (Array.isArray(locs)){
      if (locs.length && Array.isArray(locs[0])) return locs.some(e=>matchOne(e?.[1]));
      return locs.some(matchOne);
    }
    if (locs && typeof locs==='object') return Object.values(locs).some(matchOne);
    return false;
  }

  function getLeadTimeForVariant(v){
    const meta = byIdMeta.get(v.id);
    return (meta?.new_my_fields?.lead_time)
        || (productMetafields?.new_my_fields?.lead_time)
        || '';
  }

  function getCurrentSelection(){
    const sel = {};
    optionsWithValues.forEach(o => {
      const n = o.name;
      // supports "Size" and "options[Size]" (and lowercase)
      const q = [
        `input[name="${CSS.escape(n)}"]:checked`,
        `input[name="options[${CSS.escape(n)}]"]:checked`,
        `input[name="${CSS.escape(n.toLowerCase())}"]:checked`,
        `input[name="options[${CSS.escape(n.toLowerCase())}]"]:checked`
      ].join(',');

      const inp = document.querySelector(q);
      if (inp) {
        sel[n] = inp.value;
      } else {
        const pos = (o.position || 1) - 1;
        sel[n] = productData.product?.selected_or_first_available_variant?.options?.[pos]
              || productData.product?.variants?.[0]?.options?.[pos]
              || null;
      }
    });
    return sel;
  }

  function variantMatches(selection, valueForTarget){
    const nameToPos = new Map(optionsWithValues.map(o=>[o.name,(o.position||1)-1]));
    return variants.filter(v=>{
      for (const o of nonTargetOptions){
        const pos = nameToPos.get(o.name);
        if (pos==null) continue;
        const need = selection[o.name];
        if (need && v.options[pos]!==need) return false;
      }
      if (targetOption){
        const fpos = nameToPos.get(TARGET_OPTION_NAME);
        if (fpos == null) return false;
        if (v.options[fpos] !== valueForTarget) return false;
      }
      return true;
    });
  }

  // ===== Groups (instock / mto / sale) =====
  function computeGroups(selection){
    const out = { instock: [], mto: [], sale: [] };
    if (!targetOption || !Array.isArray(targetOption.values)) return out;

    const seen = new Set();
    targetOption.values.forEach(val=>{
      const value = val?.name || val?.value || val;
      if (!value || seen.has(value)) return;

      const matched = variantMatches(selection, value);
      if (!matched.length) return;

      const available = matched.filter(v=>isAvailableAnywhere(v.id));
      if (!available.length) return;

      const chosen = available[0];
      const leadTime = getLeadTimeForVariant(chosen);
      const anySale = available.some(v => (v.compare_at_price && v.compare_at_price > v.price));
      const anyInStockHere = available.some(v => isInStockAtLocation(v.id));

      const entry = { value, leadTime, instockHere: anyInStockHere };
      if (anySale) out.sale.push(entry);
      if (anyInStockHere) out.instock.push({ value, leadTime });
      else out.mto.push({ value, leadTime });

      seen.add(value);
    });

    return out;
  }

  function toTileObjects(arr){
    return arr.map((obj)=>{
      const { value, leadTime, instockHere = false } = obj || {};
      const h = value.toLowerCase().replace(/[^a-z0-9]+/g,'-');
      const p = parseFabricLabel(value);
      return {
        value,
        value_handle: h,
        fabric: p.fabric,
        desc: p.desc,
        color: p.color,
        groupTitle: p.groupTitle,
        leadTime,
        swatch_image: swatchByValue.get(value) || null,
        meta_img: metaFabricImg.get(value) || null,
        instockHere: !!instockHere  
      };
    });
  }

  // ===== Helpers for Color grid IDs / names =====
  function getProductFormId(){
    const form = document.querySelector('form[id^="product-form-"]');
    return form ? form.id : null;
  }
  function optionInputNameFor(optName){
    const exact = document.querySelector(`input[name="options[${CSS.escape(optName)}]"]`);
    if (exact) return `options[${optName}]`;
    const lo = optName.toLowerCase();
    const lower = document.querySelector(`input[name="options[${CSS.escape(lo)}]"]`);
    if (lower) return `options[${lo}]`;
    return optName;
  }
  const handleize = (s)=> String(s).toLowerCase()
    .normalize('NFKD').replace(/[\u0300-\u036f]/g,'')
    .replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
  const fallbackSwatchURL = (val)=>{
    const h = handleize(val);
    const host = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : location.host;
    return `//${host}/cdn/shop/files/${h}_84x84.png`;
  };

  // ===== THEME-STYLE COLOR GRID inside each TAB panel =====
  function renderColorPanel(panelEl, tiles, selection, blockTitle){
    panelEl.innerHTML = '';
    if (!tiles.length) return;
  
    const leadSet = new Set(tiles.map(t => t.leadTime).filter(Boolean));
    const header = document.createElement('div');
    header.className = 'product-options__header';
    header.innerHTML = `
      <hr class="product-options__option-divider">
      ${leadSet.size === 1 ? `<p class="product-options__headerLead">Lead Time: ${[...leadSet][0]}</p>` : ''}`;
    panelEl.appendChild(header);
  
    const byLead = new Map();
    tiles.forEach(t=>{
      const lt = t.leadTime || '';
      if (!byLead.has(lt)) byLead.set(lt, []);
      byLead.get(lt).push(t);
    });
  
    const formId  = (function(){
      const f = document.querySelector('form[id^="product-form-"]');
      return f ? f.id : null;
    })();
    const inputNm = (function(optName){
      if (document.querySelector(`input[name="options[${CSS.escape(optName)}]"]`)) return `options[${optName}]`;
      const lo = optName.toLowerCase();
      if (document.querySelector(`input[name="options[${CSS.escape(lo)}]"]`)) return `options[${lo}]`;
      return optName;
    })(TARGET_OPTION_NAME);
  
    const current = selection[TARGET_OPTION_NAME];
  
    const handleize = (s)=> String(s).toLowerCase()
      .normalize('NFKD').replace(/[\u0300-\u036f]/g,'')
      .replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
    const fallbackSwatchURL = (val)=>{
      const h = handleize(val);
      const host = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : location.host;
      return `//${host}/cdn/shop/files/${h}_84x84.png`;
    };
  
    byLead.forEach((items, lt)=>{
      if (leadSet.size > 1 && lt){
        const sub = document.createElement('div');
        sub.className = 'product-options__header';
        sub.innerHTML = `<p class="product-options__headerLead">Lead time: ${lt}</p>`;
        panelEl.appendChild(sub);
      }
  
      const grid = document.createElement('div');
      grid.className = 'product-options__option-grid color-grid';
      panelEl.appendChild(grid);
  
      items.forEach(t=>{
        // if (shouldHideByMeta(t.value, selection)) return; 
        const id = `option-${TARGET_OPTION_NAME.toLowerCase()}-${t.value_handle}-${Math.random().toString(36).slice(2,7)}`;
  
        const wrap = document.createElement('div');
        wrap.className = 'product-options__option-value js-panel-item'; // ⬅️ mark item
  
        const input = document.createElement('input');
        input.type  = 'radio';
        input.className = 'swatch-input__input';
        input.id    = id;
        input.name  = inputNm;
        input.value = t.value;
        if (formId) input.setAttribute('form', formId);
        if (current === t.value) input.checked = true;
        // input.addEventListener('change', ()=>{
        //   input.dispatchEvent(new Event('input',  { bubbles:true }));
        //   input.dispatchEvent(new Event('change', { bubbles:true }));
        // });
  
        const label = document.createElement('label');
        label.className = 'swatch-input__label swatch-input__label--square';
        label.setAttribute('for', id);
        label.setAttribute('title', t.value);
  
        const sw = document.createElement('span');
        sw.className = 'swatch swatch--square';
        const imgUrl = t.swatch_image || t.meta_img || fallbackSwatchURL(t.value);
        sw.setAttribute('style', `--swatch--color: ; --swatch--background: url(${imgUrl});`);
  
        const text = document.createElement('span');
        text.textContent = t.value;
  
        label.appendChild(sw);
        label.appendChild(text);
        wrap.appendChild(input);
        wrap.appendChild(label);
        grid.appendChild(wrap);
      });
    });
  
    applyViewMore(panelEl);
    attachIOSVariantTapFix(panelEl);
  }
  


  // ===== FABRIC renderers (unchanged) =====
  function renderInstockPanel(panelEl, tiles, selection){
    panelEl.innerHTML = '';
    if (!tiles.length) return;
  
    const groups = new Map(); // leadTime => items[]
    tiles.forEach(t=>{
      const key = t.leadTime || '—';
      if(!groups.has(key)) groups.set(key,[]);
      groups.get(key).push(t);
    });
  
    const currentVal = selection && selection[TARGET_OPTION_NAME];
  
    groups.forEach((items, lt)=>{
      if (lt && lt !== '—'){
        const hdr = document.createElement('div');
        hdr.className = 'product-options__header';
        hdr.innerHTML = `<p class="product-options__headerLead" ltcustom stockVariant>Lead time: ${lt}</p>`;
        panelEl.appendChild(hdr);
      }
  
      const wrap = document.createElement('div');
      wrap.className = 'fabric-tiles';
      panelEl.appendChild(wrap);
  
      items.forEach(t=>{
        // if (shouldHideByMeta(t.value, selection)) return;
        const item = document.createElement('div');
      item.className = 'newLabelContainer';
        const label = document.createElement('label');
        label.className = 'fabric-tile cylindoVariant__option js-panel-item'; // ⬅️ mark item
        label.tabIndex = 0;
        label.setAttribute('data-value', t.value);
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = TARGET_OPTION_NAME;
        input.id   = `Fabric_${t.value_handle}`;
        input.value = t.value;
        input.classList.add('visually-hidden');  
       label.setAttribute('for', input.id);  
        if (currentVal === t.value){
          input.checked = true;
          label.classList.add('is-selected');
        }
        input.addEventListener('change', ()=>{
          label.classList.add('is-selected');
          document.querySelectorAll('.fabric-tile').forEach(x=>{ if(x!==label) x.classList.remove('is-selected'); });
          // input.dispatchEvent(new Event('input',{bubbles:true}));
          // input.dispatchEvent(new Event('change',{bubbles:true}));
        });
  
        const sw = document.createElement('div');
        sw.className = 'cylindoVariant__optionDisplay';
        const imgSrc = t.swatch_image || t.meta_img || null;
        if (imgSrc){
          const img = document.createElement('img');
          img.src = imgSrc; img.alt = t.value;
          sw.appendChild(img);
        } else {
          sw.textContent = t.fabric || '—';
        }
  
        const pf = document.createElement('p');
        pf.className = 'cylindoVariant__option-fabric';
        pf.textContent = t.fabric || '';
  
        const pc = document.createElement('p');
        pc.className = 'cylindoVariant__option-color';
        pc.textContent = t.color || '';
  
        const pd = document.createElement('p');
        pd.className = 'cylindoVariant__option-desc';
        pd.textContent = t.desc || '';
  
        const btn = document.createElement('button');
               btn.type = 'button';                               
                btn.setAttribute('toggle-modal','modal-'+t.value);
        btn.textContent = 'View Details';
         // BRUTE FORCE: any tap on tile selects radio (except the modal button)
       label.addEventListener('click', (e) => {
           if (e.target.closest('button,[toggle-modal]')) return; // don't change selection when opening modal
           if (!input.checked) {
             input.checked = true;
             input.dispatchEvent(new Event('input',  { bubbles:true }));
             input.dispatchEvent(new Event('change', { bubbles:true }));
           }
         });
  
        label.appendChild(input);
        label.appendChild(sw);
        label.appendChild(pf);
        label.appendChild(pc);
        label.appendChild(pd);
        item.appendChild(label);  // label first
        item.appendChild(btn);    // button as sibling of label
        wrap.appendChild(item);
      });
    });
  
    applyViewMore(panelEl);
    attachIOSVariantTapFix(panelEl);
  }
  

  function renderMtoLike(panelEl, tiles, selection){
    renderInstockPanel(panelEl, tiles, selection);
  }
  function renderSalePanel(panelEl, tiles, selection){
    panelEl.innerHTML = '';
    if (!tiles.length) return;
  
    // split: in-stock first, then MTO
    const instockFirst = tiles.filter(t => t.instockHere);
    const mtoLater     = tiles.filter(t => !t.instockHere);
  
    // local helper: same layout as renderInstockPanel (by lead time)
    const renderBlock = (list) => {
      if (!list.length) return;
  
      const groups = new Map(); // leadTime => items[]
      list.forEach(t=>{
        const key = t.leadTime || '—';
        if(!groups.has(key)) groups.set(key, []);
        groups.get(key).push(t);
      });
  
      const currentVal = selection && selection[TARGET_OPTION_NAME];
  
      groups.forEach((items, lt)=>{
        if (lt && lt !== '—'){
          const hdr = document.createElement('div');
          hdr.className = 'product-options__header';
          hdr.innerHTML = `<p class="product-options__headerLead" ltcustom stockVariant>Lead time: ${lt}</p>`;
          panelEl.appendChild(hdr);
        }
  
        const wrap = document.createElement('div');
        wrap.className = 'fabric-tiles';
        panelEl.appendChild(wrap);
  
        items.forEach(t=>{
          // if (shouldHideByMeta(t.value, selection)) return;
          const item = document.createElement('div');
          item.className = 'newLabelContainer';
          const label = document.createElement('label');
          label.className = 'fabric-tile cylindoVariant__option js-panel-item';
          label.tabIndex = 0;
          label.setAttribute('data-value', t.value);
  
          const input = document.createElement('input');
          input.type = 'radio';
          input.name = TARGET_OPTION_NAME;
          input.id   = `Fabric_${t.value_handle}`;
          input.value = t.value;
          input.hidden = true;
  
          if (currentVal === t.value){
            input.checked = true;
            label.classList.add('is-selected');
          }
  
          input.addEventListener('change', ()=>{
            label.classList.add('is-selected');
            document.querySelectorAll('.fabric-tile').forEach(x=>{
              if(x!==label) x.classList.remove('is-selected');
            });
          });
  
          const sw = document.createElement('div');
          sw.className = 'cylindoVariant__optionDisplay';
          const imgSrc = t.swatch_image || t.meta_img || null;
          if (imgSrc){
            const img = document.createElement('img');
            img.src = imgSrc; img.alt = t.value;
            sw.appendChild(img);
          } else {
            sw.textContent = t.fabric || '—';
          }
  
          const pf = document.createElement('p');
          pf.className = 'cylindoVariant__option-fabric';
          pf.textContent = t.fabric || '';
  
          const pc = document.createElement('p');
          pc.className = 'cylindoVariant__option-color';
          pc.textContent = t.color || '';
  
          const pd = document.createElement('p');
          pd.className = 'cylindoVariant__option-desc';
          pd.textContent = t.desc || '';
  
          const btn = document.createElement('button');
          btn.setAttribute('toggle-modal','modal-'+t.value);
          btn.textContent = 'View Details';
  
          label.appendChild(input);
          label.appendChild(sw);
          label.appendChild(pf);
          label.appendChild(pc);
          label.appendChild(pd);
          item.appendChild(label);  // label first
          item.appendChild(btn);    // button as sibling of label
          wrap.appendChild(item);
        });
      });
    };
  
    // render in the wanted order:
    renderBlock(instockFirst);
    renderBlock(mtoLater);
  
    applyViewMore(panelEl);
  }
  function attachIOSVariantTapFix(root) {
    const tiles = root.querySelectorAll('.fabric-tile.cylindoVariant__option');
    tiles.forEach((label) => {
      if (label.__iosBound) return;
      label.__iosBound = true;
  
      const input = label.querySelector('input[type="radio"]');
      if (!input) return;
  
      const handler = (e) => {
        // modal/open buttons ko ignore
        // if (e.target.closest('button,[toggle-modal]')) return;
  
        // kill native path (iOS label quirks) + stop other handlers
        // if (e) {
        //   if (e.cancelable) e.preventDefault();
        //   e.stopPropagation();
        //   if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        // }
  
        // ensure selection + events
        if (!input.checked) {
          // focus helps iOS sometimes
          try { input.focus({ preventScroll: true }); } catch {}
          input.checked = true;
        }
        // fire twice (some themes swallow first)
        const fireOnce = () => {
          input.dispatchEvent(new Event('input',  { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        };
        fireOnce();
        requestAnimationFrame(fireOnce);
        
      };
  
      // bind on multiple phases to be extra safe on iOS
      label.addEventListener('pointerup', handler, { passive: false });
      label.addEventListener('touchend',  handler, { passive: false });
      label.addEventListener('click',     handler, { passive: false });
    });
  }
  

  // ===== Render All =====
  function renderAll(){
    const selection   = getCurrentSelection();
    const grouped     = computeGroups(selection);
    const instockTile = toTileObjects(grouped.instock);
    const mtoTile     = toTileObjects(grouped.mto);
    const saleTile    = toTileObjects(grouped.sale);

    const instockPanel = $('#panel-instock', tabsRoot);
    const mtoPanel     = $('#panel-mto', tabsRoot);
    const salePanel    = $('#panel-sale', tabsRoot);

    if (IS_COLOR_ONLY){
      // Tabs visible + theme swatch grid inside panels
      renderColorPanel(instockPanel, instockTile, selection, 'In Stock');
      renderColorPanel(mtoPanel,mtoTile,selection, 'Made To Order');
      renderColorPanel(salePanel,saleTile,selection, 'Sale');
    } else {
      // Fabric (or other target) = your existing tiles UI
      renderInstockPanel(instockPanel,instockTile,selection);
      renderMtoLike(mtoPanel,mtoTile,selection);
      renderSalePanel(salePanel,saleTile,selection);
    }
    attachIOSVariantTapFix(tabsRoot);
    // safety: if current selection is not in active tab, uncheck it
    const activePanel = $('.fabric-tabs__panel.is-active', tabsRoot);
    const currentVal  = selection[TARGET_OPTION_NAME];
    if (activePanel && currentVal){
      const inActive = activePanel.querySelector(
        `input[name="${CSS.escape(optionInputNameFor(TARGET_OPTION_NAME))}"][value="${CSS.escape(currentVal)}"]`
      );
      if (!inActive){
        const checked = tabsRoot.querySelector(
          `input[name="${CSS.escape(optionInputNameFor(TARGET_OPTION_NAME))}"][value="${CSS.escape(currentVal)}"]`
        );
        if (checked) checked.checked = false;
      }
    }
    refreshTabsAvailability();
  }

  // Tabs switching (works for both cases)
  $$('.fabric-tabs__btn', tabsRoot).forEach(btn=>{
    if (!btn.__bound) {
      btn.addEventListener('click', ()=>{
        if (btn.disabled || btn.getAttribute('aria-disabled')==='true' || btn.classList.contains('is-disabled')) return;
        tabsRoot.__userPicked = true;                 // ⬅️ ye naya
        $$('.fabric-tabs__btn', tabsRoot).forEach(b=>b.classList.remove('is-active'));
        btn.classList.add('is-active');
        console.log('added')
        const tab = btn.dataset.tab;
        $$('.fabric-tabs__panel', tabsRoot).forEach(p=>p.classList.remove('is-active'));
        $(`#panel-${tab}`, tabsRoot)?.classList.add('is-active');
      });
      btn.__bound = true;
    }
  });
  
  

  // Re-render on any non-target option change (Size/Orientation etc.)
  function bindNonTargetChange(){
    nonTargetOptions.forEach(o=>{
      const n = o.name;
      const sel = [
        `input[name="${CSS.escape(n)}"]`,
        `input[name="options[${CSS.escape(n)}]"]`,
        `input[name="${CSS.escape(n.toLowerCase())}"]`,
        `input[name="options[${CSS.escape(n.toLowerCase())}]"]`
      ].join(',');

      $$(sel).forEach(inp=>{
        if (!inp.__fabricTabsBound) {
          inp.addEventListener('change', renderAll);
          inp.addEventListener('input',  renderAll);
          inp.__fabricTabsBound = true;
        }
      });
    });

    // delegated fallback if theme re-renders
    document.addEventListener('change', (e)=>{
      const t = e.target;
      if (!(t instanceof HTMLInputElement)) return;
      const nm = (t.name || '').toLowerCase();
      const hit = nonTargetOptions.some(o=>{
        const on = o.name.toLowerCase();
        return nm === on || nm === `options[${on}]`;
      });
      if (hit) renderAll();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindNonTargetChange();
    renderAll();
    initFabricHoverDelegation();
    setTimeout(autoPickOnLoad, 0);
  
  
    
  });
  
  
})();


